import api from './api';
import { refreshSession, SCHEDULED_MIN_INTERVAL_MS } from './sessionRefresh';
import type { LoginResponse } from '../types/user';

export async function login(username: string, password: string): Promise<LoginResponse> {
  const params = new URLSearchParams();
  params.append('username', username);
  params.append('password', password);
  const { data } = await api.post<LoginResponse>('/auth/login', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
  return data;
}

/**
 * 定時續期（由 `useTokenRefresh` 呼叫）。
 *
 * 走共用的 `refreshSession`，與 401 攔截器共用同一把鎖，並帶 25 分鐘冷卻窗：
 * 多開幾個分頁時，只有第一個到的那次會真的輪替權杖，其餘視為已續期。
 * 不這樣做的話每個分頁各有一支 30 分鐘的計時器、掛載時又各續一次，
 * 同一個 httpOnly cookie 會被送去輪替好幾遍 ⇒ 觸發後端的重用偵測、整組權杖被撤銷。
 *
 * 回傳 true＝此刻 cookie 是新的（本次續期成功，或冷卻窗內別人剛續過）。
 * 原本回傳後端的 `LoginResponse`，但唯一的呼叫端從來沒用過它（憑證在 httpOnly cookie，
 * 不經 JS），改回傳布林讓「續期有沒有成功」可以被判斷。
 */
export async function refreshToken(): Promise<boolean> {
  return refreshSession(SCHEDULED_MIN_INTERVAL_MS);
}

export async function getMe() {
  const { data } = await api.get('/auth/me');
  return data;
}

/** 通知後端登出以寫入稽核（best-effort，失敗不阻斷前端清除；短逾時避免後端無回應時卡住）。 */
export async function logout(reason: 'manual' | 'idle' = 'manual'): Promise<void> {
  await api.post(`/auth/logout?reason=${reason}`, null, { timeout: 4000 });
}
